import { useState } from 'react';
import './Onboarding.css';

const STEPS = [
  {
    emoji: '🤖',
    title: 'Welcome to Model Hub',
    body: 'Find and compare 500+ AI models from OpenAI, Anthropic, Google, Groq, NVIDIA and more — all in one place.',
  },
  {
    emoji: '🔍',
    title: 'Filter by platform',
    body: 'Looking for models you can use in Cursor, Windsurf, or just in your browser? Use the "Available in" filter to find exactly that.',
  },
  {
    emoji: '⭐',
    title: 'Save your favorites',
    body: 'Tap ♡ on any model card to add it to your favorites. Access them instantly from the Home tab.',
  },
];

interface Props {
  onDone: () => void;
}

export function Onboarding({ onDone }: Props) {
  const [step, setStep] = useState(0);
  const isLast = step === STEPS.length - 1;
  const current = STEPS[step];

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-card">
        <div className="onboarding-emoji">{current.emoji}</div>
        <h2 className="onboarding-title">{current.title}</h2>
        <p className="onboarding-body">{current.body}</p>

        <div className="onboarding-dots">
          {STEPS.map((_, i) => (
            <span key={i} className={`dot ${i === step ? 'active' : ''}`} />
          ))}
        </div>

        <div className="onboarding-actions">
          {!isLast && (
            <button className="btn-skip" onClick={onDone}>Skip</button>
          )}
          <button
            className="btn-next"
            onClick={() => isLast ? onDone() : setStep(s => s + 1)}
          >
            {isLast ? 'Get Started 🚀' : 'Next →'}
          </button>
        </div>
      </div>
    </div>
  );
}
